import { render, staticRenderFns } from "./LoginScreen.vue?vue&type=template&id=5c231cfb&"
import script from "./LoginScreen.vue?vue&type=script&lang=js&"
export * from "./LoginScreen.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports